import React, { useState, useEffect } from 'react';
import { LogOut, ChevronDown } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const UserProfile = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  // Get user initials for avatar
  const getInitials = (name) => {
    if (!name) return 'U';
    const names = name.split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Fixed: Move useEffect before early return to avoid conditional hook calls
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.user-profile-dropdown')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleLogout = async () => {
    try {
      await logout();
      setIsOpen(false);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  // Early return after all hooks are called
  if (!isAuthenticated || !user) return null;

  return (
    <div className="relative user-profile-dropdown">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-3 px-3 py-2  hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-black"
      >
      
          <div className="w-8 h-8 bg-gradient-to-br from-gray-800 to-black  flex items-center justify-center text-white text-sm font-semibold shadow-sm">
            {getInitials(user.displayName || user.name)}
          </div>
          
          {/* User Info */}
        <div className="text-left hidden md:block">
          <div className="text-sm font-medium text-gray-900 truncate max-w-32">
            {user.displayName || user.name || 'User'}
          </div>
          <div className="text-xs text-gray-500 truncate max-w-32">
            {user.email}
          </div>
        </div>
        
        {/* Dropdown Arrow */}
        <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-72 bg-white  shadow-lg border border-gray-200 py-2 z-50">
          {/* User Info Header */}
          {/* <div className="px-4 py-3 border-b border-gray-200">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700  flex items-center justify-center text-white text-lg font-semibold">
                {getInitials(user.displayName || user.name)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-gray-900 truncate">
                  {user.displayName || user.name || 'User'}
                </div>
                <div className="text-sm text-gray-500 truncate">
                  {user.email}
                </div>
                {user.jobTitle && (
                  <div className="text-xs text-gray-400 truncate">
                    {user.jobTitle}
                  </div>
                )}
              </div>
            </div>
          </div> */}
          
          {/* Menu Items */}

          
        
                <div className="border-t border-gray-200 py-2">
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center space-x-3 px-4 py-3 text-left hover:bg-gray-100 transition-colors text-black hover:text-black"
                >
                  <LogOut className="h-4 w-4" />
                  <span className="text-sm font-medium">Sign out</span>
                </button>
                </div>
                
                {/* Footer */}
   
        </div>
      )}
    </div>
  );
};

export default UserProfile;